export default __webpack_public_path__ + "static/media/northern-lights-bg.1fabfd42.png";